import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-unresolved
import waIcon from 'images/chatbots/whatsapp.svg';

const WhatsappCallHeaderMC = memo(() => {
  const { t } = useTranslation('Inbox');

  return (
    <div className="tw-mb-6 tw-flex tw-gap-2 tw-self-start">
      <img src={waIcon} className="tw-w-5 tw-h-5" title="Whatsapp" alt="WhatsApp" />
      <span className="tw-text-sm tw-font-medium tw-text-gray-950">
        {t('wsCallSidebar.whatsappCall')}
      </span>
    </div>
  );
});

WhatsappCallHeaderMC.displayName = 'WhatsappCallHeaderMC';

export default WhatsappCallHeaderMC;
